import $ from 'jquery';

// Function to show tooltip
function showTooltip(countyName) {
  const countyElement = $(`#${countyName.replace(/ /g, '_')}_TX`);
  const tooltip = $('#county_tooltip');
  tooltip.text(countyName);

  // Calculate the position relative to the container
  const containerOffset = $('#texas_county_map_select').offset();
  const elementOffset = countyElement.offset();
  const relativeTop = elementOffset.top - containerOffset.top;
  const relativeLeft = elementOffset.left - containerOffset.left;
  // Adjust tooltip position
  tooltip.css('top', `${relativeTop - 40}px`);
  tooltip.css('left', `${relativeLeft}px`);
  tooltip.css('display', 'block');
}

// Event handler for clicking the zip search confirm button or pressing Enter
function handleZipSearch() {
  const zipCode = $('#zip_select').val();
  const countyInfoContent = $('#county_info_content');
  // Clear any previously displayed county-info-item elements
  countyInfoContent.find('.county-info-item').addClass('hidden');
  $('#texas_county_map_select').find('path').removeClass('selected');
  $('#county_tooltip').css('display', 'none'); // Hide tooltip initially

  if (zipCode.length === 5) {
    const countyInfoItem = countyInfoContent.find(
      `.county-info-item[data-county-zips*="${zipCode}"]`
    );
    if (countyInfoItem.length > 0) {
      countyInfoItem.removeClass('hidden');
      const countyName = countyInfoItem.data('county-name');
      $('.county-select select').val(countyName);
      const countyId = countyName.replace(/ /g, '_') + '_TX';
      $(`#${countyId}`).addClass('selected');
      showTooltip(countyName); // Show tooltip
    }
  } else {
    $('.county-select select').val('');
  }
}

// Event listener for zip search confirm button click
$('#zip_search_confirm').on('click', handleZipSearch);

// Event listener for Enter key press
$('#zip_select').on('keypress', function (e) {
  if (e.which === 13) {
    handleZipSearch();
  }
});

$('.county-select select').on('change', function () {
  $('#zip_select').val('');
  const countyName = $(this).val();
  const countyId = countyName.replace(/ /g, '_') + '_TX';
  $('#texas_county_map_select').find('path').removeClass('selected');
  $(`#${countyId}`).addClass('selected');
  const countyInfoContent = $('#county_info_content');
  countyInfoContent.find('.county-info-item').addClass('hidden');
  const countyInfoItem = countyInfoContent.find(
    `.county-info-item[data-county-name="${countyName}"]`
  );
  if (countyInfoItem.length > 0) {
    countyInfoItem.removeClass('hidden');
    showTooltip(countyName); // Show tooltip
  }
});

$('#texas_county_map_select').on('click', 'path', function () {
  const countyName = $(this).attr('id').replace(/_TX/, '').replace(/_/g, ' ');
  const countySelect = $('.county-select select');
  countySelect.val(countyName);
  countySelect.trigger('change');
});

// on map county hover, display tooltip with the county name, hide again on mouseout
$('#texas_county_map_select').on('mouseover', 'path', function (e) {
  const countyName = $(this).attr('id').replace(/_TX/, '').replace(/_/g, ' ');
  showTooltip(countyName);
});

$('#texas_county_map_select').on('mouseout', 'path', function (e) {
  $('#county_tooltip').css('display', 'none');
});
